import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { BlankComponent } from './layouts/blank/blank.component';
import { FullComponent } from './layouts/full/full.component';
import { MatTableModule } from '@angular/material/table';
import { CommonModule } from '@angular/common';


// import {
//   canActivateGuard,
//   canMatchGuard,
// } from './pages/authentication/guards/auth.guard';

import { authGuard } from './pages/authentication/guards/auth.guard';
import { DocumentTemplatesComponent } from './pages/document-templates/document-templates.component';

const routes: Routes = [
  {
    path: '',
    redirectTo: '/register',
    pathMatch: 'full'
  },
  {
    path: 'boxed-register',
    redirectTo: '/register',
    pathMatch: 'full'
  },
  {
    path: 'authentication',
    loadChildren: () =>
      import('./pages/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: '',
    component: FullComponent,
    canActivate: [authGuard],
    children: [
      {
        path: 'dashboards',
        loadChildren: () =>
          import('./pages/dashboards/dashboards.module').then(
            (m) => m.DashboardsModule
          ),

      },
      {
        path: 'setting/document-templates',
        loadChildren: () => import('./pages/document-templates/document-templates.module').then(
          (m) => m.DocumentTemplateModule
        )
        // component: DocumentTemplatesComponent,

      },{
        path: 'signature-requests',
        loadChildren: () => import('./features/signature-requests/signature-requests.routes').then(
          (m) => m.SIGNATURE_REQUESTS_ROUTES
        )
      },
      {
        path: 'security',
        loadChildren:() => 
          import('./pages/inner-security/inner-security.module').then(
            m => m.InnerSecurityModule
          )
      },
      {
        path: 'setting/documents',
        loadChildren: () => import('./pages/document-type/document-type.module').then(
          (m) => m.DocumentTypeModule
        )
      },
      {
        path: 'setting/minute-approval-rules',
        loadChildren: () => import('./pages/setting-pages/minute-request-approve-rule-setting/minute-request-approve-rule-setting.module').then(
          (m) => m.MinuteRequestApproveRuleSettingModule
        )
      },
    ],
  },
  {
    path: '',
    component: BlankComponent,
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./pages/authentication/authentication.module').then(
            (m) => m.AuthenticationModule
          ),
      },
      {
        path: 'landingpage',
        loadChildren: () =>
          import('./pages/theme-pages/landingpage/landingpage.module').then(
            (m) => m.LandingPageModule
          ),
      },
    ],
  },
  {
    path: '**',
    redirectTo: 'register',
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    MatTableModule,
    CommonModule
  ],
  exports: [RouterModule],
  declarations: [
  ],
})
export class AppRoutingModule {}
